module.exports = {
	"detailPeerings": "/api/cps/peerConn/findPeerConn",
	"modifyPeerConn": "/api/cps/peerConn/modifyPeerConn"
};



// WEBPACK FOOTER //
// ./src/api/peering/detail/config.js